import React from 'react';
import * as dates from 'date-arithmetic';
import TimeGrid from 'react-big-calendar/lib/TimeGrid';
import { withNamespaces } from 'react-i18next';
import moment from 'moment';

class CalendarNext7DaysWeekView extends React.Component {
	render() {
		const { date, events } = this.props;
		const range = CalendarNext7DaysWeekView.range(date, events);
		return <TimeGrid {...this.props} range={range} eventOffset={15} />;
	}
}

CalendarNext7DaysWeekView.range = (date, lessons) => {
	let start = moment(date).startOf('day').toDate();
	let end = moment(date).add(6, 'day').endOf('day').toDate();
	let current = start;
	let range = [];

	let days = lessons.filter(lesson => lesson.start >= start && lesson.start < end)
						.map(lesson => moment(lesson.start).format('LL'));

	while (dates.lte(current, end, 'day')) {
		//if no classes in week show empty calendar with all days
		if (days.length === 0 || days.indexOf(moment(current).format('LL')) > -1) {
			range.push(current);
		}
		current = dates.add(current, 1, 'day');
	}

	return range;
};

CalendarNext7DaysWeekView.navigate = (date, action) => {
	// disable navigation
	return date;
};

CalendarNext7DaysWeekView.title = () => {
	return '';
};

export default withNamespaces()(CalendarNext7DaysWeekView);